import { useTranslation } from 'react-i18next';
import { CheckboxField } from '@/components/form';

/**
 * Shared checkbox grid for cabinet doubled/exterior flags. Used by both
 * AddCabinetDialog and CatalogCabinetFormPage.
 */
export function CabinetDoubledCheckboxes() {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-4 gap-3">
      <CheckboxField
        name="carcassDoubled"
        label={t('projectItems.cabinets.fields.carcassDoubled')}
        pill
      />
      <CheckboxField
        name="carcassExteriorFront"
        label={t('projectItems.cabinets.fields.carcassExteriorFront')}
        pill
      />
      <CheckboxField
        name="intermediarDoubled"
        label={t('projectItems.cabinets.fields.intermediarDoubled')}
        pill
      />
      <CheckboxField
        name="politeDoubled"
        label={t('projectItems.cabinets.fields.politeDoubled')}
        pill
      />
    </div>
  );
}
